import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { GlobalConstants } from "../common/global-constants";
import { BOItem } from "../models/BOItem.model";

@Injectable()
export class OrphanDiseaseService{
    myAppUrl = GlobalConstants.apiURL;
    myApiUrl = 'api/OrphanDisease';

    constructor(private http:HttpClient){}

    getAll(orphanDiseaseFilter:string):Observable<BOItem[]>{
        return this.http.get<BOItem[]>(this.myAppUrl + this.myApiUrl +'/'+ orphanDiseaseFilter);
    }
}